"use strict";

var XMLHttpRequest = window.XMLHttpRequest; // eslint-disable-line

module.exports = XMLHttpRequest;


//////////////////
// WEBPACK FOOTER
// ./~/ipfs-mini/lib/lib/XMLHttpRequest-browser.js
// module id = 204
// module chunks = 0